import { truncateText } from 'utils/strings'

import Chip from 'components/lib/DesignSystem/Chip'

const MAX_TAG_SIZE = 16

export const participantsObjectToArray = (participantsObject) => {
  // this function is to parse the selectedParticipant map to match the selector structure.
  // TODO: optimize and remove these limitions by creating a better architecture
  const participantsArray = []
  for (const [key, value] of Object.entries(participantsObject)) {
    for (let i = 0; i < value.length; i++) {
      participantsArray.push(`${key}//${value[i]}`)
    }
  }
  return participantsArray
}

export const constructSelectorLabels = (title, metaData) => {
  const icon = metaData && metaData.type ? iconsMap[metaData.type] : 'tags'
  return (
    <div className="label-container">
      <img
        className="participants-icon"
        src={`/static/webapp/images/participant-selector/${icon}.svg`}
      />
      <span className="selector-label-text">{title}</span>
      {metaData && metaData.subLabel && (
        <span className="selector-label-metadata">{metaData.subLabel}</span>
      )}
    </div>
  )
}

export const sortParticipants = (x, y) => {
  const userFullNamX = x.fullName ? x.fullName : `${x.first_name} ${x.last_name}`
  const userFullNamY = y.fullName ? y.fullName : `${y.first_name} ${y.last_name}`

  return userFullNamX > userFullNamY ? 1 : -1
}

export const getSelectedGroups = (value) => {
  const selectedGroups = {}

  if (value.length) {
    for (let i = 0; i < value.length; i++) {
      const currentOptionParams = value[i]?.split('//')
      const optionParent = currentOptionParams[0]
      const optionValue = currentOptionParams[1]
      if (!(optionParent in selectedGroups)) {
        // first time getting this parentCategory
        selectedGroups[optionParent] = []
      }
      selectedGroups[optionParent].push(optionValue)
    }
  }

  return selectedGroups
}

export const buildTreeArray = (dataStructure, selectableFlag, labelConstructor) => {
  // search API returns array of searched items, not map
  const isSearchData = Array.isArray(dataStructure)
  const itemsArray = []

  if (!isSearchData) {
    // typical participants map

    for (const [key, value] of Object.entries(dataStructure)) {
      const mainCategory = key
      const arrField = {
        title:
          key === 'All Company' ? (
            labelConstructor(mainCategory, {
              type: mainCategory,
              subLabel: `(${Array.isArray(value) ? value.length : value} mailboxes)`,
            })
          ) : (
            <div className="main-category-container">{mainCategory}</div>
          ),
        checkable: key === 'All Company',
        selectable: key === 'All Company',
        value: key === 'All Company' ? 'All Company//All Company' : mainCategory,
        children: [],
      }
      if (Array.isArray(value)) {
        // category got array of items like Cities:['Tel-Aviv', 'Raanana', ...]

        arrField.children = value.map((val) => ({
          key: `${mainCategory}//${val}`,
          title: labelConstructor(val, { type: mainCategory }),
          value: `${mainCategory}//${val}`,
          parent: mainCategory,
        }))
      } else {
        for (const [subKey, subValue] of Object.entries(value)) {
          let titleLabelByType
          let valueBytype = `${key}//${subKey}`
          switch (key) {
            case 'Cities':
            case 'Countries':
            case 'Departments':
            case 'Segments':
            case 'Tags':
            case 'Titles':
            case 'Awareness Levels':
            case 'Featured Groups':
              const subCategoryMailBoxes = subValue
              titleLabelByType = labelConstructor(subKey, {
                type: key,
                subLabel: subCategoryMailBoxes
                  ? `(${subCategoryMailBoxes} mailboxes)`
                  : '(0 mailboxes)',
              })
              break
            case 'Names':
              const userDetails = subValue
              valueBytype = `Names//${userDetails.mail}`
              titleLabelByType = labelConstructor(userDetails.full_name, {
                type: key,
                subLabel: `(${userDetails.mail})`,
              })
              break
            default:
          }
          arrField.children.push({
            title: titleLabelByType,
            value: valueBytype,
            selectable: selectableFlag,
            parent: key,
            mailboxes: subValue,
            key: valueBytype,
          })
        }
      }
      itemsArray.push(arrField)
    }
  } else {
    // data return as flatten list from server
    for (const option of dataStructure) {
      const metadata = { type: option.tag }
      Object.assign(metadata, option.mail ? { subLabel: option.mail } : null)

      const arrField = {
        title: labelConstructor(option.name, metadata),
        selectable: true,
        value: option.mail
          ? `${option.tag}//${option.mail}//${option.name}`
          : `${option.tag}//${option.name}`,
        parent: option.tag,
        key: option.mail
          ? `${option.tag}//${option.mail}//${option.name}`
          : `${option.tag}//${option.name}`,
      }
      itemsArray.push(arrField)
    }
  }

  return itemsArray
}

export const tagRenderer = ({ label, value, onClose }) => {
  const currentOptionParams = value?.split('//')
  const optionValue = currentOptionParams?.[1]

  return (
    <Chip
      noMaxWidth
      id={label}
      checked
      checkedStyle="selected"
      label={value ? truncateText(optionValue, MAX_TAG_SIZE) : label}
      onClose={onClose}
      onMouseDown={(e) => e.stopPropagation()}
    />
  )
}

export const iconsMap = {
  'Awareness Levels': 'tags',
  Cities: 'city',
  Countries: 'country',
  Departments: 'group',
  'Featured Groups': 'tags',
  Names: 'user',
  Segments: 'segments-icon',
  Tags: 'tags',
  Titles: 'titles',
  'All Company': 'allCompany',
}
